module.exports = __webpack_public_path__ + "static/media/AIRA.78c5b48c.jpg";